import { AppRouteProps } from "@harea/component";
import ProjectDayOffCreateContainer from "./container/ProjectEventEditContainer";
import { ProjectAppointmentCreateVacationRoutes } from "views/create/views/vacation/ProjectAppointmentCreateVacationRoutes";
import { ProjectAppointmentCreateMissingRoutes } from "views/create/views/missing/ProjectAppointmentCreateMissingRoutes";

export const ProjectEventEditRoutes: Array<AppRouteProps> = [
    {
        path: "edit",
        element: <ProjectDayOffCreateContainer />,
        roles: ["TIMEOFF"],
        children: [
            ...ProjectAppointmentCreateVacationRoutes,
            ...ProjectAppointmentCreateMissingRoutes
        ]
    },
];
